import React from 'react';
import '../../App.css';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../../styles/theme.js';
import { Typography } from '@material-ui/core';
import flexedigital from '../../assets/images/flexedigital.png';

const OurGroup = () => {
  const classes = useStyles();

  return (
    <>
      <section className={classes.section}>
        <div className={classes.inner}>
          <div className={classes.rowContainer}>
            {/* LEFT */}
            <div className={classes.leftCol}>
              <div className={classes.heading}>
                <Typography className={classes.blackTitle}>Quienes</Typography>
                <Typography className={classes.greenTitle}>Somos</Typography>
                <Typography className={classes.thinTitle}>NUESTRO GRUPO</Typography>
              </div>

              <Typography className={classes.ourGroupText}>
                Nos dedicamos a desarrollar servicios y soluciones especializadas con las
                herramientas tecnológicas adecuadas para potenciar la innovación y el mercado
                financiero global a través de plataformas de pago, comercio electrónico e
                inteligencia analítica para negocios y empresas.
              </Typography>
            </div>

            {/* RIGHT */}
            <div className={classes.rightCol}>
              <img src={flexedigital} alt="flexedigital" className={classes.flexedigitalImage} />
            </div>
          </div>
        </div>
      </section>

      <div className={classes.centerContainer}>
        <div className={classes.yellowContainer}>
          <Typography className={classes.bottomText}>
            Conoce más en{' '}
            <a
              href="https://flexedigital.com/"
              className={classes.link}
              target="_blank"
              rel="noreferrer"
            >
              flexedigital.com
            </a>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default OurGroup;

const useStyles = makeStyles({
  section: {
    width: '100%',
    backgroundColor: '#fff',
  },
  inner: {
    maxWidth: 1100,
    margin: '0 auto',
    padding: '0 24px',
  },

  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 80,
    paddingTop: 60,
    paddingBottom: 40,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 40,
      paddingTop: 40,
    },
  },

  leftCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      textAlign: 'center',
    },
  },

  rightCol: {
    flex: '0 0 420px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  heading: {
    marginBottom: 24,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 16,
    },
  },

  blackTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 56,
    lineHeight: 1.0,
    color: theme.palette.black.main,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: 44,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 40,
      textAlign: 'center',
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 28,
    },
  },

  greenTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 56,
    lineHeight: 1.0,
    color: theme.palette.primary.main,
    textAlign: 'left',
    marginTop: 4,
    [theme.breakpoints.down('md')]: {
      fontSize: 44,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 40,
      textAlign: 'center',
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 28,
    },
  },

  thinTitle: {
    fontFamily: 'Lato',
    fontWeight: 300,
    fontSize: 18,
    letterSpacing: 1.2,
    marginTop: 12,
    color: theme.palette.black.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      textAlign: 'center',
      width: '100%',
    },
  },

  ourGroupText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: 18,
    lineHeight: 1.7,
    maxWidth: 520,
    textAlign: 'left',
    color: theme.palette.black.main,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: 16,
      maxWidth: '100%',
    },
  },

  flexedigitalImage: {
    width: '100%',
    maxWidth: 430,
    height: 'auto',
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 360,
    },
  },
  centerContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '30px 24px 60px',
  },

  yellowContainer: {
    backgroundColor: theme.palette.secondary.main,
    padding: '18px 24px',
    borderTopLeftRadius: 30,
    borderBottomRightRadius: 30,
    maxWidth: 520,
    width: '100%',
  },

  bottomText: {
    fontSize: 18,
    fontWeight: 500,
    fontFamily: 'Montserrat',
    textAlign: 'center',
    margin: 0,
  },

  link: {
    fontSize: 18,
    fontWeight: 700,
    fontFamily: 'Montserrat',
    color: theme.palette.black.main,
    textDecoration: 'none',
  },
});
